import { connect } from 'react-redux';
import { changeRoute, resign } from '../actions';
import Confirm from '../components/Confirm';


const mapStateToProps = state => ({
  route: state.route,
  isFailure: state.verifyStatus.isFailure
});

const mapDispatchToProps = dispatch => ({
  onConfirm: () => {
    dispatch(changeRoute('DonationInProgress'));
  },
  resign: () => {
    dispatch(resign());
  }
});


export default connect(mapStateToProps, mapDispatchToProps)(Confirm);



/** WEBPACK FOOTER **
 ** ./src/containers/ConfirmContainer.jsx
 **/